import { useMemo } from "react";
import { useMedicationsStore } from "../stores/medicationsStore";
import type { Hint } from "../types";

export const useMergedTerms = (aiTerms: Hint[]): Hint[] => {
  const medications = useMedicationsStore((s) => s.medications);

  return useMemo(() => {
    if (!medications.length) return aiTerms;
    if (!aiTerms.length) return medications;

    const termMap = new Map<string, Hint>();

    for (const med of medications) {
      termMap.set(med.term.toLowerCase(), med);
    }

    for (const ai of aiTerms) {
      termMap.set(ai.term.toLowerCase(), ai);
    }

    return Array.from(termMap.values());
  }, [aiTerms, medications]);
};
